import { DocumentalBancoSolidario } from '../components/Documental/DocumentalBancoSolidario';
import Layout from "../components/Layout";
import { useLocation } from "react-router-dom";

const DocumentalBancoSolidarioPage = () => {
  const location = useLocation();
  const {
    id,
    NumeroSolicitud,
    nombre,
    cedula,
    fecha,
    almacen,
    foto,
    vendedor,
    consulta,
  } = location.state || {};

  if (!id) {
    console.error("No se encontraron datos en la ubicación");
  }

  return (
    <>
      <Layout />
      <DocumentalBancoSolidario
        id={id}
        NumeroSolicitud={NumeroSolicitud}
        nombre={nombre}
        cedula={cedula}
        fecha={fecha}
        almacen={almacen}
        foto={foto}
        vendedor={vendedor}
        consulta={consulta}
      />
    </>
  );
};

export default DocumentalBancoSolidarioPage;
